/**
 * LandingRedirect — iter.255 · Fase 11 UX Refactor
 * -------------------------------------------------
 * Envuelve el `index` route de `/app`. Lee `user.preferences.default_landing`
 * y hace redirect a la ruta preferida. Si no hay preferencia o es
 * "dashboard", renderiza el `Dashboard` normal.
 *
 * Mapping:
 *   dashboard  → <Dashboard /> (default)
 *   sales      → /app/sales-today
 *   inventory  → /app/inventory
 *   menus      → /app/menus
 *   more       → /app/settings
 *
 * Sincronizado cross-device vía backend PATCH /api/auth/me/preferences.
 */
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "../../lib/api";
import Dashboard from "../../pages/Dashboard";

const ROUTE_MAP = {
  dashboard: null,             // stay on <Dashboard />
  sales:     "/app/sales-today",
  inventory: "/app/inventory",
  menus:     "/app/menus",
  more:      "/app/settings",
};

export default function LandingRedirect() {
  const [landing, setLanding] = useState(undefined); // undefined = loading

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const me = await api.request("/auth/me");
        if (cancelled) return;
        setLanding(me?.preferences?.default_landing || "dashboard");
      } catch {
        if (!cancelled) setLanding("dashboard");
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (landing === undefined) return <Dashboard />; // optimistic first paint
  const target = ROUTE_MAP[landing];
  if (!target) return <Dashboard />;
  return <Navigate to={target} replace />;
}
